import { fn } from '@ember/helper';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import or from 'ember-truth-helpers/helpers/or';
import BvBtn from 'volta/components/bv-btn';
import BaseCell from 'volta/components/cell/base-cell';
import stopPropagation from 'volta/helpers/stop-propagation';

import type { TOC } from '@ember/component/template-only';
import type { CellBaseCellSignature } from './base-cell';

const CellCodeDescCellComponent: TOC<CellBaseCellSignature> = <template>
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    @scrollToRow={{@scrollToRow}}
    class='code-desc-cell'
    as |baseCell|
  >
    <span class='code'>
      {{baseCell.value.code}}
    </span>
    <span class='desc' title={{baseCell.value.description}}>
      {{baseCell.value.description}}
    </span>
    {{#if (or baseCell.value.action baseCell.value.link)}}
      <span class='quick-view-icon'>
        <BvBtn
          @size='sm'
          @rounded={{true}}
          @subtle={{true}}
          @route={{baseCell.value.link}}
          @routeModel={{baseCell.value.linkParam}}
          @routeQuery={{baseCell.value.linkQuery}}
          @iconLeft={{or baseCell.value.quickViewIcon 'eye'}}
          @onClick={{if
            baseCell.value.action
            (stopPropagation (fn (optional baseCell.value.action) baseCell.value.context))
          }}
        />
      </span>
    {{/if}}
  </BaseCell>
</template>;

export default CellCodeDescCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::CodeDescCell': typeof CellCodeDescCellComponent;
    'cell/code-desc-cell': typeof CellCodeDescCellComponent;
  }
}
